// Page numbers with gaps, e.g. 1 … 4 5 6 … 12
const getPageList = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const from = Math.max(2, current - 1);
  const to = Math.min(total - 1, current + 1);
  if (from > 2) pages.push("…");
  for (let p = from; p <= to; p++) pages.push(p);
  if (to < total - 1) pages.push("…");
  pages.push(total);
  return pages;
};

export default function Pagination({
  pageNumber,
  pageSize,
  totalRecords,
  onChange,
  disabled = false,
  label = "records",
}) {
  if (!totalRecords) return null;

  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));
  const pageStart = (pageNumber - 1) * pageSize;

  return (
    <div className="pager">
      <span>
        Showing {pageStart + 1}–{Math.min(pageStart + pageSize, totalRecords)}{" "}
        of {totalRecords} {label}
      </span>
      <div className="pager-btns">
        <button
          className="btn btn-ghost btn-sm"
          disabled={disabled || pageNumber <= 1}
          onClick={() => onChange(pageNumber - 1)}
        >
          Previous
        </button>
        {getPageList(pageNumber, totalPages).map((p, i) =>
          p === "…" ? (
            <span key={`gap-${i}`} className="pager-gap">
              …
            </span>
          ) : (
            <button
              key={p}
              className={`btn btn-sm ${
                p === pageNumber ? "btn-primary" : "btn-ghost"
              }`}
              disabled={disabled}
              onClick={() => onChange(p)}
            >
              {p}
            </button>
          ),
        )}
        <button
          className="btn btn-ghost btn-sm"
          disabled={disabled || pageNumber >= totalPages}
          onClick={() => onChange(pageNumber + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
